import React, { useState, useEffect } from 'react';
import { useMediaQuery } from 'react-responsive';
import moment from 'moment';

import {
  BackArrowSmallIcon,
  ChevronActiveIcon,
  ForwardArrowSmallIcon,
} from '../../../assets';
import { monthsList } from '../../../config/dateConfig';

import { MonthListProps } from '../models/calendarModels';

const MonthList: React.FC<MonthListProps> = ({
  year,
  setCurrentYear,
  month,
  setCurrentMonth,
  setNextYear,
  setNextMonth,
  closeMonthList,
  isCurrentMonth,
}) => {
  const [activeMonth, setActiveMonth] = useState<number | null>(month);
  const isMobile = useMediaQuery({ query: '(max-width: 768px)' });
  const selectedYear = moment().year();

  const currentYearItem = moment().year();
  const currentMonthItem = moment().month();

  // Function to split the array into chunks of size n
  const chunkArray = (arr: any[], size: number) => {
    const chunkedArr = [];
    let i = 0;
    while (i < arr.length) {
      chunkedArr.push(arr.slice(i, i + size));
      i += size;
    }
    return chunkedArr;
  };

  const handleChangeMonth = (monthIndex: number) => {
    if (isCurrentMonth) {
      setCurrentMonth(monthIndex);
      setNextMonth(monthIndex === 11 ? 0 : monthIndex + 1);
      if (monthIndex === 11) {
        setNextYear(year + 1);
      }
    } else {
      setNextMonth(monthIndex);
      setCurrentMonth(monthIndex === 0 ? 11 : monthIndex - 1);
      if (monthIndex === 0) {
        setCurrentYear(year - 1);
      }
    }
    setActiveMonth(monthIndex);
    closeMonthList();
  };

  const handleChangeYear = (increment: number) => {
    setCurrentYear(year + increment);
    setNextYear(year + increment);
    if (month === 11 && isCurrentMonth) {
      setNextYear(year + increment + 1);
    }
    if (month === 0 && !isCurrentMonth) {
      setNextYear(year + increment);
      setCurrentYear(year + increment - 1);
    }
  };

  // Chunk the months array into groups of three
  const monthsChunks = chunkArray(monthsList, 3);

  // Get the current year and month
  const currentYear = new Date().getFullYear();
  const currentMonth = new Date().getMonth();
  //const isDisabledArrow = year <= currentYear;

  useEffect(() => {
    if (selectedYear === year) {
      setActiveMonth(month);
    } else {
      setActiveMonth(null);
    }
  }, [year]);

  return (
    <div className="d-flex-start-start p-absolute top-0 left-0 w-100 z1 bg-white">
      <div
        className={`${isMobile && 'mt-1rem p-0-1rem'} d-flex-row-space-between w-100 mb-2_25rem `}
      >
        <button
          className="btn-icon"
          onClick={() => handleChangeYear(-1)}
          //disabled={isDisabledArrow}
        >
          {isMobile ? (
            <ChevronActiveIcon />
          ) : (
            <BackArrowSmallIcon className="w-1_5rem h-1_5rem" />
          )}
        </button>
        <span className="ff-arial fw-600 fs-1_25rem">{year}</span>
        <div
          className="d-flex-center icon-hovered"
          onClick={() => handleChangeYear(1)}
        >
          {isMobile ? (
            <ChevronActiveIcon className="rotate-180" />
          ) : (
            <ForwardArrowSmallIcon className="w-1_5rem h-1_5rem" />
          )}
        </div>
      </div>
      {/* Render each chunk of months */}
      <div className="d-flex-start-start w-100 pb-1_5rem">
        {monthsChunks.map((chunk, chunkIndex) => (
          <div key={chunkIndex} className="d-flex-row-space-between w-100">
            {chunk.map((monthName, monthIndex) => {
              const fullMonthIndex = chunkIndex * 3 + monthIndex;
              const isDisabled =
                (isCurrentMonth &&
                  (year < currentYear ||
                    (year === currentYear && fullMonthIndex < currentMonth))) ||
                (!isCurrentMonth &&
                  (year < currentYear ||
                    (year === currentYear && fullMonthIndex <= currentMonth)));

              return (
                <div
                  key={monthIndex}
                  className="d-flex-center w-33_3 p-1_25rem-0_5rem"
                >
                  <button
                    className={`${fullMonthIndex === activeMonth && !isDisabled ? 'active' : ''}
              ${currentMonthItem === fullMonthIndex && currentYearItem === year ? 'current-month' : ''}
                    btn-calendar`}
                    onClick={() => handleChangeMonth(fullMonthIndex)}
                    //disabled={isDisabled}
                  >
                    <span>{monthName}</span>
                  </button>
                </div>
              );
            })}
          </div>
        ))}
      </div>
    </div>
  );
};

export default MonthList;
